var CONFUSEDCMS = CONFUSEDCMS || {},
	CSSCONSTANTS = CSSCONSTANTS || {};
CONFUSEDCMS.eventDecorator = CONFUSEDCMS.eventDecorator || {};

if (!window.console) {
	window.console = { log: function () {} };
}

// EventDefinition
(function (ns) {
	'use strict';

	ns.EventDefinition = function (selector, eventName, functionName, params) {
		if (!(this instanceof ns.EventDefinition)) {
			return new ns.EventDefinition(selector, eventName, functionName, params);
		}
		this.selector = selector;
		this.eventName = eventName;
		this.functionName = functionName;
		this.params = params;

		return this;
	};
})(CONFUSEDCMS.eventDecorator);

// EventDefinitionList
(function (ns) {
	'use strict';
	ns.EventDefinitionList = [];
	ns.EventDefinitionList.Add = function (eventDefinition) {
		if (eventDefinition.constructor === ns.EventDefinition) {
			this.push(eventDefinition);
		}
	};
	ns.EventDefinitionList.ProcessAll = function () {
		// careful here, we are slightly mixing metaphors! had to use a variable cos length property changes each iteration!
		var length = ns.EventDefinitionList.length;
		for (var i = 0; i < length; i++) {
			var eventDefinition = ns.EventDefinitionList.pop();
			if (eventDefinition.selector === '') {
				ns.ProcessFunction(eventDefinition);
			} else {
				ns.ProcessEvent(eventDefinition);
			}
		}
	};
})(CONFUSEDCMS.eventDecorator);

// Process a single event definition by finding the function and wiring up the event to fire it
(function (ns, w, $) {
	'use strict';

	// functions in name spaces cannot be directly referenced, so
	// we need to dig the function out of the context (usually the window object)
	function getFunctionByName(functionName, context) {
		var namespaces = functionName.split('.');
		var func = namespaces.pop();
		for (var i = 0; i < namespaces.length; i++) {
			context = context[namespaces[i]];
		}
		return context[func];
	}

	ns.ProcessEvent = function (eventDefinition) {
		// first get the function out of the supplied namespace
		var fn = getFunctionByName(eventDefinition.functionName, w);
		if (typeof fn !== 'function') {
			return false;
		}

		// Now wire up the function to the requested event name, for a given selector, passing in any require parameters.
		$(document.body).on(eventDefinition.eventName, eventDefinition.selector, function () {
			fn.apply(this, eventDefinition.params);
		});

		return true;
	};

	ns.ProcessFunction = function (eventDefinition) {
		// first get the function out of the supplied namespace
		var fn = getFunctionByName(eventDefinition.functionName, w);

		if (typeof fn !== 'function') {
			return false;
		}
		fn.apply(fn, eventDefinition.params);
		return true;
	};
})(CONFUSEDCMS.eventDecorator, window, jQuery);
